import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
const Party = () => {
  const [partyData, setPartyData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const searchParam = [
    "contact_no",
    "name",
    "city_name",
    "state_name",
    "party_type"
  ];

  const getParty = () => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [0]}).then(
      (res) => {
        if (res.data.status === 1) {
          setPartyData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          
        });
      }
    );
  };

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PARTY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = partyData.filter((r) => r.id != row.id);
              setPartyData(newData);
              toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const searchParty = (value) => {
    setSearchValue(value);
  };

  const search = (items) => {
    if (searchValue.length > 0) {
      return items.filter((item) => {
        return searchParam.some((newItem) => {
          return (
            item[newItem] &&
            item[newItem]
              .toString()
              .toLowerCase()
              .indexOf(searchValue.toLowerCase()) > -1
          );
        });
      });
    }
    return items;
  };

  useEffect(() => {
    getParty();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-6">
            <h1>Party <small className="me-2">({partyData.length})</small></h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{width: 300}}>
              <input
                type="text"
                value={searchValue}
                onChange={(e) => searchParty(e.target.value)}
                className="form-control"
                placeholder="Search"
              />
            </div>
            <Link to={"/sales/party/add"} className="btn btn-primary">
                <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add Party
            </Link>
          </div>
        </div>
          <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                         <th>#</th>
                          <th>Name</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th>GST No.</th>
                          <th
                            className="text-center"
                            style={{ width: "200px" }}
                          >
                            Actions
                          </th>
                      </tr>
                    </thead>
                    <tbody>
                      {search(partyData).map((row, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>
                              {row.name}
                              </td>
                              <td>{row.contact_no}</td>
                              <td>
                                {row.city_name}, {row.state_name}
                              </td>
                              <td>{row.gst_no}</td>
                              <td
                                className="d-flex justify-content-center gap-2"
                                style={{ width: "200px" }}
                              >
                                <Link
                                  to={"/sales/party/edit/" + row.id}
                                  className="btn btn-sm btn-secondary mr-2"
                                >
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                <button
                                  onClick={() => deleteParty(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Party;
